import loginActions from './loginActions';
import registerActions from './registerActions';
import routeActions from './routeActions';
import menuActions from './menuActions';
import editorActions from './editorActions';
import templateActions from './templateActions';
import articleActions from './articleActions';
import navigationActions from './navigationActions';
import uploadActions from './uploadActions';

const actions = {
	loginActions,
	registerActions,
	routeActions,
	menuActions,
	editorActions,
	templateActions,
	articleActions,
	navigationActions,
	uploadActions
}

export default actions;